import { IURIPartial } from '@cian/http-api/shared/URI/IURI';

export const getTrackingBankiruUri = (advSub: number, transactionId: string): IURIPartial => ({
  scheme: 'https',
  host: 'tracking.banki.ru',
  path: '/SP2A3',
  query: `adv_sub=${advSub}&transaction_id=${transactionId}`,
});
